var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atoms/icon/title/single") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atoms/icon/title/single",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#75593A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 23.5,
    x2: 23,
    y2: 23.5,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18.5,
    x2: 23,
    y2: 18.5,
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12.5,
    x2: 23,
    y2: 12.5,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.465135,30 L28,30 C29.1045695,30 30,29.1045695 30,28 L30,7.77600485 C30,6.67143535 29.1045695,5.77600485 28,5.77600485 L7.465135,5.77600485 C6.3605655,5.77600485 5.465135,6.67143535 5.465135,7.77600485 L5.465135,28 C5.465135,29.1045695 6.3605655,30 7.465135,30 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31306718,24.2239951 L2,24.2239951 C0.8954305,24.2239951 2.09738034e-15,23.3285646 0,22.2239951 L0,2 C-5.7935996e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L22.7545824,0 C23.7699927,-4.08572436e-16 24.6242541,0.760893194 24.7412601,1.76953958 L24.889882,3.05073103 C24.9595232,3.65107123 24.7539603,4.25070723 24.3306432,4.68205496",
    id: "Stroke-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendIcon);
export default __webpack_public_path__ + "static/media/recommendIcon.6c374e0e8d66e5a2945162d06c5ec9b3.svg";
export { ForwardRef as ReactComponent };